import React, { JSX, ReactNode } from "react";
import { Box, TableBody, TableRow, TableCell, TableContainer, Typography, Tooltip, styled, tableCellClasses, Table } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Image } from 'mui-image'
import { BorderBottom, BorderTop } from "@mui/icons-material";
import { heIL } from "@mui/material/locale";

export enum SkillsRepresentationVariant {
  VARIANT1 = 1,
}

export enum ListSkillsRepresentationVariant {
  VARIANT1 = 1,
}


export interface SkillsItemDataProps {
  title: String;
  description: String;
  image? : String;
  children?: ReactNode;
} 

export interface ListSkillItemDataProps {
  skills: SkillsItemDataProps[];
  categoryTitle: String;
  variant: ListSkillsRepresentationVariant;
}

export interface SingleSkillItemDataProps extends Partial<SkillsItemDataProps> {
  variant: SkillsRepresentationVariant;
}

export const SkillDataComponent = ({ title, variant, description, image, children }: SingleSkillItemDataProps): JSX.Element => {
  const { t } = useTranslation("skills");

  const imagePath = image ? `./images/${image}` : ""; 
  return (
    <Box>
      <Box>
        {imagePath && variant && variant === SkillsRepresentationVariant.VARIANT1 && (
          <Image
            width={"inherit"}
            height={"1em"}
            fit={'scale-down'}
            duration={10}
            src={imagePath as string}
          />  
        )}
        <Typography variant="h5">{title}</Typography>
      </Box>
      <Box>
        <Typography variant="h6">{description}</Typography>
      </Box>
      {children && (
        <Box>
         {children}
       </Box>
      )}
    </Box>
  )
}

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  border: 0,
  //'&:nth-of-type(odd)': {
  //  backgroundColor: theme.palette.action.hover,
  //},
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.body}`]: {
    BorderBottom: 0,
    ...theme.typography.body2,
    //BorderTop: 0,
    fontWeight: 600,
    fontSize: "1.5rem",
  },
}));

const StyledCategoryHeader = styled(Typography)(({ theme }) => ({
  '&': {
    //BorderBottom: 0,
    background: "linear-gradient(to right, #F83901, #FCE26F)",
    height: "2.5em",
    //"font-size": "25px",
    //"font-weight": "700",
    //"align-content": "center",
    fontSize: "25px",
    fontWeight: 700,
  },
}));


export const ListSkillsDataComponent = ({ skills, categoryTitle, variant }: ListSkillItemDataProps) => {

  return (
    <>
      <Box justifyContent={"space-around"} alignSelf={"center"}>
        <StyledCategoryHeader>{categoryTitle}</StyledCategoryHeader>
      </Box>
      <TableContainer>
        <Table>
          <TableBody>
            {skills.map((skill, index) => {
              const imagePath = skill.image ? `./images/${skill.image}` : "";
              return (
                <>
                  <Tooltip title={skill.description} key={`skill-tooltip-row-one-cell-one-${index}`}>
                  <StyledTableRow key={`skill-table-row-one-${index}`}>
                    <StyledTableCell align="left" key={`skill-table-row-one-cell-one-${index}`}>
                      {imagePath && variant && variant === ListSkillsRepresentationVariant.VARIANT1 && (
                        <Image
                          width={"inherit"}
                          height={"3em"}
                          fit={'scale-down'}
                          duration={10}
                          src={imagePath as string}
                        />  
                      )} 
                    </StyledTableCell>
                    <StyledTableCell align="left" key={`skill-table-row-one-cell-two-${index}`}>
                      {skill.title}
                    </StyledTableCell>
                  </StyledTableRow>
                  </Tooltip>
                  {/*<TableRow key={`skill-table-row-two-${index}`}>
                    <TableCell colSpan={2} align="left" key={`skill-table-row-two-cell-one-${index}`}>
                      {skill.description}
                    </TableCell>
                  </TableRow>*/}
                </>  
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}